<template>
  <Wrapper>
    <AppSpinner v-if="isLoading" variant="primary" size="md" />
    <slot v-else />
  </Wrapper>
</template>

<script>
import styled from "vue-styled-components";
import AppSpinner from "./AppSpinner";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 1.5rem 0;
`;

export default {
  name: "ContentLoader",
  components: {
    AppSpinner,
    Wrapper
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
